import {
    Backdrop,
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Grid,
    TextField,
    Typography,
    Alert,
    useTheme,
    ThemeProvider
} from "@mui/material";
import React, { useState, useEffect } from "react";
import WestIcon from "@mui/icons-material/West";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { customLocale } from "../utils/CalendarFunctions/CalendarConfig";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import moment from "moment";
import { format, utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";
import { getUserFromCache } from "../user/UserCommon";
import { graphql, graphqlOperation, postApi } from "../modules/AmplifyServices";
import { execReadBySortkey } from "../modules/DBService";
import * as scheduleQueries from "../modules/ScheduleQueries";
import * as mutations from "../graphql/mutations";
import * as queries from "../graphql/queries";
import {
    formatDateInfoAttributes,
    getBookingDateDescription,
    getBookingDateDescriptionInTimezone
} from "../modules/TimeService";
import { auditOverrideBooking } from "../modules/Audit";
import {
    isBlockedTime,
    checkProviderAvailabilityForRechedule,
    getGeoLocOfBooking
} from "../modules/CheckAvailability";
import {
    getCompanyLocation,
    getCompanyLocationId,
    getProviderLocation,
    getProviderLocationId
} from "../modules/ReschedulingFunctions";
import { mbxUserAtom } from "../atoms/atoms";
import { useAtom } from "jotai";
import {
    createProviderScheduleBK,
    getSBsForReschedule
} from "../modules/ScheduleService";
import { extractLocationIdFromScheduleinfo } from "../utils/providerLocationUtils";
import {
    addExceptionToRepeatApptCreation,
    FREQ_WEEKLY,
    getRelevantRRule
} from "../modules/RecurringBookingsUtilityFunctions";
import SuggestedTimesSection from "../forms/SuggestedTimeSection";
import { DialogTheme } from "../styles/DialogTheme";
import { RescheduleSlotsList } from "./RescheduleSlotsList";
import { useQuery } from "@tanstack/react-query";
import {
    bookingGeoLocationAtom,
    providerUnavaialbleTimeBlocksAtom,
    selectedBookingForRescheduleAtom,
    getCurrentBookingDateAtom,
    selectedRescheduleDateTimeAtom,
    suggestionLookAheadStartDateAtom,
    storedSuggestionsAtom,
    calendarDateAtom,
    errorAtom,
    isRecurringBookingAtom,
    showRecurrenceSettingsSectionAtom,
    hideSuggestionsAtom,
    recurringRecheduleChoiceAtom,
    getCurrentBookingClientNameAtom
} from "../atoms/providerReschedule";
import {
    customTimeActionsAtom,
    RECURRING_PATTERN_INDEF
} from "../atoms/booking";
import { RepeatingSetup } from "../forms/RecurringSetup";
import {
    setRecurringSettingsFromRruleAtom,
    rruleAtom,
    hasTotalNumberOfSessionsChangedAtom,
    originalTotalNumberOfSessionsAtom,
    setRecurringDetailAtom,
    setRecurringWeekDaysAtom
} from "../atoms/recurringSettings";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import ProviderRescheduleConfirmationModal from "./ProviderRescheduleConfirmationModal";
function ProviderRescheduleModal(props) {
    const [mbxUser] = useAtom(mbxUserAtom);
    const [loading, setLoading] = useState(true);
    const [unavailableTimeBlocks, setProviderUnavailableTimeBlocks] = useAtom(
        providerUnavaialbleTimeBlocksAtom
    );
    const [booking, setSelectedBookingForReschedule] = useAtom(
        selectedBookingForRescheduleAtom
    );
    const [geoLoc, setBookingGeoLocation] = useAtom(bookingGeoLocationAtom);
    const [currentBookingDate] = useAtom(getCurrentBookingDateAtom);
    const [selectedRescheduleDateTime, setSelectedRescheduleDateTime] = useAtom(
        selectedRescheduleDateTimeAtom
    );
    const [, setSuggestionLookAheadStartDate] = useAtom(
        suggestionLookAheadStartDateAtom
    );
    const [, setStoredSuggestions] = useAtom(storedSuggestionsAtom);
    const [calendarDate, setCalendarDate] = useAtom(calendarDateAtom);
    const [isRescheduling, setIsRescheduling] = useState(false);
    const [error, setError] = useAtom(errorAtom);
    const [, setRecurringSettings] = useAtom(setRecurringSettingsFromRruleAtom);
    const [rrule] = useAtom(rruleAtom);
    const [hasTotalNumberOfSessionsChanged] = useAtom(
        hasTotalNumberOfSessionsChangedAtom
    );
    const [, setOriginalTotalNumberOfSessions] = useAtom(
        originalTotalNumberOfSessionsAtom
    );
    const [, resetRecurringDetail] = useAtom(setRecurringDetailAtom);
    const [, setRecurringWeekDays] = useAtom(setRecurringWeekDaysAtom);
    const [isRecurringBooking] = useAtom(isRecurringBookingAtom);
    const [showRecurrenceSettingsSection] = useAtom(
        showRecurrenceSettingsSectionAtom
    );
    const [hideSuggestions] = useAtom(hideSuggestionsAtom);
    const [, setRecurringRecheduleChoiceAtom] = useAtom(
        recurringRecheduleChoiceAtom
    );
    const [currentBookingClientName] = useAtom(getCurrentBookingClientNameAtom);
    const [showConfirmationMessage, setShowConfirmationMessage] =
        useState(false);
    const [hasDateOrTimeChanged, setHasDateOrTimeChanged] = useState(false);
    const [originalRRule, setOriginalRRule] = useState(null);
    const [originalRRulelist, setOriginalRRuleList] = useState([]);
    const [disableCalendar, setDisableCalendar] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [errorType, setErrorType] = useState("error");
    const [showBackdrop, setShowBackdrop] = useState(false);
    const SCHEDPKSKSPLITAT = "::";
    const theme = useTheme();
    const [
        recurringBookingAllOrSelectedOverride,
        setRecurringBookingAllOrSelectedOverride
    ] = useState(false);
    const [SBs, setSBs] = useState(null);
    const [showCustomDateTimeDialog, setShowCustomDateTimeDialog] =
        useState(false);
    const [showNormalSlots, setShowNormalSlots] = useState(false);
    /* useEffect is only called once when the reschduleModal Dialogue opens */
    const { isLoading: isLoadingUnavailableTimeblocks } = useQuery({
        queryKey: ["get-provider-unavailability"],
        queryFn: async () => {
            try {
                let { items, errors } = await execReadBySortkey({
                    opname: "listProviderSchedules",
                    op: scheduleQueries.listProviderSchedules,
                    id: {
                        id: `C-${mbxUser.company.id}|P-${mbxUser.provider.id}`
                    },
                    skey: { scheduleinfo: { beginsWith: "BUT" } },
                    filter: { active: { ne: false } },
                    limit: 500
                });
                if (errors) throw errors;
                return items;
            } catch (e) {
                console.log(e);
            }
        },
        onSuccess: (unavailableTimeBlocks) => {
            setProviderUnavailableTimeBlocks(unavailableTimeBlocks);
        }
    });

    const { isLoading: isLoadingGeoLocation } = useQuery({
        queryKey: ["get-booking-geolocation"],
        queryFn: async () => {
            try {
                let latlng;
                const pksk = booking.timeblockid.split(SCHEDPKSKSPLITAT);
                const {
                    data: { getProviderSchedule: scheduleRecord }
                } = await graphql(
                    graphqlOperation(scheduleQueries.getProviderSchedule, {
                        id: pksk[0],
                        scheduleinfo: pksk[1]
                    })
                );
                if (scheduleRecord) {
                    latlng = {
                        lat: scheduleRecord.latitude,
                        lng: scheduleRecord.longitude
                    };
                }
                return latlng;
            } catch (e) {
                console.log(e);
            }
        },
        onSuccess: (geoLoc) => {
            setBookingGeoLocation(geoLoc);
        }
    });

    useEffect(() => {
        async function getSBsOfProvider() {
            const providerSBs = await getSBsForReschedule(booking, geoLoc);
            if (providerSBs.length) {
                setSBs(providerSBs);
                setSuggestionLookAheadStartDate(calendarDate);
            } else {
                setSBs([]);
                setShowNormalSlots(true);
            }
        }
        if (booking && geoLoc) getSBsOfProvider();
        //Function to fetch the recurring booking information for a booking, given the booking data
        const fetchRecurringInfo = async (data) => {
            try {
                //First, fetch the repeatApptCreationRecord assuming datakey starting with "O-" (recurring order has no until date)
                let result = await graphql(
                    graphqlOperation(queries.getRepeatApptCreation, {
                        id: data.companyId,
                        datakey: `O-${data.order.id}`
                    })
                );

                let repeatApptRecord = result.data.getRepeatApptCreation;
                repeatApptRecord.extented = JSON.parse(
                    result.data.getRepeatApptCreation.extented
                );
                // Pankaj: not handling the case where the old records may not have rrule in it.
                const currentRule = getRelevantRRule(
                    data.bookingDate,
                    repeatApptRecord.extented.rrule
                );
                setRecurringWeekDays(new Date(data.startdate));
                setOriginalRRule(currentRule);
                setOriginalRRuleList(repeatApptRecord.extented.rrule);
                setRecurringSettings(currentRule);
            } catch (e) {
                console.log("Error fetching recurringApptCreation record", e);
            }
            setLoading(false);
        };
        if (booking?.orderType === "ONGOING") {
            fetchRecurringInfo(booking);
        } else {
            setLoading(false);
        }
    }, [booking, geoLoc]);

    function handleConfirmation() {
        if (
            booking.orderType === "ONGOING" &&
            rrule !== originalRRule &&
            showRecurrenceSettingsSection
        ) {
            handleOverrideRecurringBookings(booking);
        } else {
            submitReschedulingHandler(booking);
        }
    }

    async function checkIsDuringBlockedTime(selectedDateTime) {
        //format of selectedDateTime must be like this "Fri Aug 04 2023 10:00:10 GMT-0400"

        const selectedDate = new Date(selectedDateTime)
            .toISOString()
            .split("T")[0];
        const selectedTime = new Date(selectedDateTime).toLocaleTimeString(
            "en-US",
            {
                hour12: false,
                hour: "2-digit",
                minute: "2-digit"
            }
        );
        let isDuringBlockedTime = await isBlockedTime(
            unavailableTimeBlocks,
            selectedDate,
            selectedTime
        );
        if (isDuringBlockedTime) {
            setErrorType("warning");
            setErrorMessage(
                "The date/time you selected is during your blocked time"
            );
            setError(true);
        }
    }

    function makeProviderScheduled(bookingDataTimeblockid) {
        const timeblock = bookingDataTimeblockid.split(SCHEDPKSKSPLITAT);
        let scheduleinfoParts = timeblock[1].split("|");
        return `${timeblock[0]}${SCHEDPKSKSPLITAT}${scheduleinfoParts[2]}|${scheduleinfoParts[3]}|${scheduleinfoParts[4]}`;
    }

    const submitReschedulingHandler = async (data) => {
        try {
            setIsRescheduling(true);
            setDisableCalendar(true);
            setShowBackdrop(true);
            const user = getUserFromCache();
            let locationData;
            let companyLocationId;
            let providerLocationId;

            if (data.timeblockid.includes("CL-")) {
                companyLocationId = await getCompanyLocationId(
                    data.timeblockid
                );

                locationData = await getCompanyLocation(companyLocationId);
            }

            if (data.timeblockid.includes("PL-")) {
                providerLocationId = await getProviderLocationId(
                    data.timeblockid
                );
                locationData = await getProviderLocation(providerLocationId);
                // isRemoteLoc = true;
            }
            // selectedRescheduleDateTime must be in provider's timezone
            // needs to be conerted to bookinglocation timezone for creating BK record

            let rescheduleDateTimeDateInfo =
                await getBookingDateDescriptionInTimezone(
                    utcToZonedTime(
                        selectedRescheduleDateTime,
                        locationData.timezone
                    ),
                    locationData.timezone,
                    data.minutes
                );
            if (rescheduleDateTimeDateInfo.dtstamp_str === currentBookingDate) {
                setDisableCalendar(false);
                setShowBackdrop(false);
                //setDisableSubmit(true);
                return;
            }

            let coords = {
                lat: locationData.latitude,
                lng: locationData.longitude
            };
            let newDate = `${moment(selectedRescheduleDateTime).format(
                "ll"
            )} at ${moment(selectedRescheduleDateTime).format("LT")}`;

            // Delete old timeblocks and create new ones
            const timeblock = data.timeblockid.split(SCHEDPKSKSPLITAT);
            const input = {
                id: timeblock[0],
                scheduleinfo: timeblock[1]
            };

            let isBookedTimeAvailable =
                await checkProviderAvailabilityForRechedule({
                    providerId: data.providerId,
                    companyId: data.companyId,
                    timezone: locationData.timezone,
                    startdate: moment(selectedRescheduleDateTime).format(
                        "YYYY-MM-DD"
                    ),
                    startTime: moment(selectedRescheduleDateTime).format(
                        "HH:mm"
                    ),
                    endTime: moment(selectedRescheduleDateTime)
                        .add(data.minutes, "minutes")
                        .format("HH:mm"),
                    geoLoc: coords,
                    overriddenbookedslot: input,
                    bookingIncrement: data.company?.bookingIncrement
                        ? data.company?.bookingIncrement
                        : 15 //does not have impact of checking availability but for the sake of consistency with the other similar functions.
                });

            if (!isBookedTimeAvailable) {
                setIsRescheduling(false);
                setSelectedRescheduleDateTime(null);
                setDisableCalendar(false);
                setShowBackdrop(false);
                setErrorType("error");
                setErrorMessage(
                    "This time conflicts with an existing booking. Please select another time."
                );
                setError(true);
                return;
            }
            let timezone = locationData.timezone;
            let dateInfo = await getBookingDateDescription(
                selectedRescheduleDateTime,
                timezone,
                data.minutes
            );
            const {
                data: {
                    deleteProviderSchedule: { MetaData }
                }
            } = await graphql(
                graphqlOperation(mutations.deleteProviderSchedule, {
                    input
                })
            );

            let bookedtimeblockData = {
                companyId: data.companyId,
                startDate: moment(selectedRescheduleDateTime).format(
                    "YYYY-MM-DD"
                ),
                endDate: moment(selectedRescheduleDateTime).format(
                    "YYYY-MM-DD"
                ),
                startTime: rescheduleDateTimeDateInfo.startTime,
                endTime: rescheduleDateTimeDateInfo.endTime,
                type: "BOOKED",
                providerId: data.provider.id,
                status: "CONFIRMED",
                tz: timezone,
                sdtutc: dateInfo.dtstamp_str,
                locationId: extractLocationIdFromScheduleinfo(
                    input.scheduleinfo
                ),
                latitude: geoLoc.lat,
                longitude: geoLoc.lng,
                ...(MetaData && { MetaData })
            };

            const newTb = await createProviderScheduleBK(bookedtimeblockData);

            // Update booking
            const bookingInput = {
                id: data.id,
                startdate: dateInfo.dtstamp_str, // moment(selectedDate).format(),
                bookingProviderId: data.provider.id,
                providerId: data.provider.id,
                timeblockid: newTb.id.includes(SCHEDPKSKSPLITAT)
                    ? newTb.id
                    : `${newTb.id}${SCHEDPKSKSPLITAT}${newTb.scheduleinfo}`,
                timezone,
                TimeDisplayInfo: JSON.stringify(dateInfo)
            };

            if (
                !data.isVirtual &&
                locationData.locationType === "CL" &&
                locationData.addressoneline
            ) {
                bookingInput.location = locationData.addressoneline;
            }
            const result = await graphql(
                graphqlOperation(mutations.updateBooking, {
                    input: bookingInput
                })
            );

            //if this is an ONGOING booking change, we need to update the repeat appt creation record with the exception,
            try {
                if (data?.orderType === "ONGOING" && data?.orderId) {
                    await addExceptionToRepeatApptCreation(
                        [data?.startdate],
                        data?.companyId,
                        data?.orderId
                    );
                }
            } catch (e) {
                console.error(
                    "Error adding exception to repeat appt creation record",
                    e
                );
            }

            await auditOverrideBooking(
                user,
                data,
                result.data.updateBooking,
                "OVERRIDE"
            );

            let old_booking_datetime = "";
            if (data.TimeDisplayInfo) {
                let old_dateInfo = JSON.parse(data.TimeDisplayInfo);
                old_booking_datetime = `${old_dateInfo.dt_full_disp}`;
            } else {
                old_booking_datetime = moment(data.startdate).format(
                    "MMM DD, YYYY [at] h:mm a"
                );
            }
            //SEnd Emails

            if (result && result.data) {
                const dataObj = {
                    client_firstname: data.client.user.firstname,
                    client_lastname: data.client.user.lastname,
                    servicetype_name: data.servicetype.name,
                    old_booking_datetime,
                    changedto_booking_datetime: `${dateInfo.dt_long_disp}`,
                    changedto_booking_time: `${dateInfo.tm_st_disp} (${dateInfo.tz_abbr_disp})`,
                    changedto_provider_firstname: data.provider.firstname,
                    changedto_provider_lastname: data.provider.lastname,
                    changedto_booking_location: bookingInput.location
                        ? bookingInput.location
                        : data.location,
                    booking_service: data.serviceName,
                    company_email: data.company.emailaddress,
                    company_name: data.company.name,
                    isRegisteredUser: data.client.user.registered
                };
                let ccAddresses = [];
                if (data.provider && data.provider.emailaddress) {
                    ccAddresses = [data.provider.emailaddress];
                }

                let toAddresses = [data.company.emailaddress];
                const { BccLists = null } = data.company;
                try {
                    if (BccLists) {
                        let bccLists = JSON.parse(BccLists);
                        if (
                            bccLists &&
                            Array.isArray(bccLists.forOrdSum) &&
                            bccLists.forOrdSum.length
                        ) {
                            toAddresses = bccLists.forOrdSum;
                        }
                    }
                } catch (e) {
                    console.error(
                        "Error parsing BccLists or handling additional email list:",
                        e
                    );
                }
                toAddresses.push(data.client.user.emailaddress);
                const result = await postApi(
                    "sendtwilioemail",
                    "/sendtwilioemailtemplate",
                    {
                        body: {
                            templateName: "appt-change.html",
                            subject: `${data.client.user.firstname}, your upcoming appointment has changed.`,
                            body: null,
                            toAddresses,
                            ccAddresses: ccAddresses,
                            replyTo: data.company.replyemailaddress
                                ? data.company.replyemailaddress
                                : data.company.emailaddress,
                            companyName: data.company.name,
                            companyId: data.company.id,
                            dataObj: dataObj,
                            companyLogoUrl: data.company.logoUrl,
                            companyColor: data.company.primaryColor,
                            authSiteUrl: process.env.REACT_APP_AUTH_SITE_URL
                        }
                    }
                );
            }
            setDisableCalendar(false);
            setShowBackdrop(false);
            setStoredSuggestions(null);
            props.refreshTable();
            props.closeRescheduleModal();
            props.openSnackbar(
                "Your booking has been rescheduled for " + newDate
            );
            setIsRescheduling(false);
            setSelectedRescheduleDateTime(null);
        } catch (err) {
            setIsRescheduling(false);
            setDisableCalendar(false);
            setShowBackdrop(false);
            console.log("Error from submitReschedulingHandler", err);
        }
    };

    async function handleOverrideRecurringBookings(bookingState) {
        try {
            setRecurringBookingAllOrSelectedOverride(false);
            setShowBackdrop(true);
            setIsRescheduling(true);

            if (
                new Date(selectedRescheduleDateTime) ===
                new Date(bookingState.startdate)
            ) {
                setDisableCalendar(false);
                setShowBackdrop(false);
                return;
            }

            let isRemoteLocation = bookingState.timeblockid.includes("|PL-")
                ? true
                : false;
            let geoLoc = await getGeoLocOfBooking(bookingState.timeblockid);
            let dateInfo = formatDateInfoAttributes(
                selectedRescheduleDateTime,
                bookingState.minutes,
                bookingState.timezone
            );
            let locationId = extractLocationIdFromScheduleinfo(
                bookingState.timeblockid
            ).slice(3);

            let body = {
                companyId: bookingState.companyId,
                orderId: bookingState.orderId,
                selectedSlot: {
                    dateInfo: dateInfo,
                    slot12: dateInfo.tm_st_disp,
                    label: dateInfo.label,
                    tz: dateInfo.tz
                },
                bookingData: {
                    location: bookingState.location,
                    serviceType: bookingState.servicetype,
                    client: {
                        firstName: bookingState.client.user.firstname,
                        lastName: bookingState.client.user.lastname,
                        id: bookingState.client.id
                    },
                    provider: {
                        firstName: bookingState.provider.firstname,
                        lastName: bookingState.provider.lastname,
                        id: bookingState.provider.id
                    },
                    isVirtual: bookingState.isVirtual,
                    isRemoteLocation,
                    rrule: rrule,
                    rruleList: originalRRulelist, // pankaj - is this existing ot includes the changed rrule?
                    rruleChanged: originalRRule !== rrule,
                    xoccurChanged: hasTotalNumberOfSessionsChanged,
                    locationId,
                    latitude: geoLoc.lat,
                    longitude: geoLoc.lng
                },
                originalBooking: {
                    id: bookingState.id,
                    startDate: bookingState.bookingDate
                }
            };
            if (bookingState.Notes) {
                body.bookingData.Notes = JSON.stringify([
                    {
                        createdBy: bookingState.Notes.createdBy,
                        createdAt: bookingState.Notes.createdAt,
                        notes: bookingState.notes
                    }
                ]);
            }
            try {
                await postApi(
                    "recurringBookingsApi",
                    "/edit-recurring-bookings",
                    {
                        body
                    }
                );
            } catch (e) {
                console.log("recurringBookingsAPI response timed out", e);
                setTimeout(() => {}, 15000);
            }
            setIsRescheduling(false);
            setSelectedRescheduleDateTime(null);
            setDisableCalendar(false);
            setShowBackdrop(false);
            setStoredSuggestions(null);
            props.refreshTable();
            props.closeRescheduleModal();
            props.openSnackbar("Success! Your bookings have been rescheduled");
        } catch (e) {
            console.log("error while creating recurring bookings", e);
            setIsRescheduling(false);
            setSelectedRescheduleDateTime(null);
            setShowBackdrop(false);
            setDisableCalendar(false);
        }
    }

    function resetOnClose() {
        setCalendarDate(null);
        setRecurringBookingAllOrSelectedOverride(false);
        setSelectedRescheduleDateTime(null);
        setProviderUnavailableTimeBlocks([]);
        setSuggestionLookAheadStartDate(null);
        setStoredSuggestions(null);
        setError(false);
        setOriginalTotalNumberOfSessions(0);
        setRecurringRecheduleChoiceAtom("SELECTED");
        setBookingGeoLocation(null);
        setSelectedBookingForReschedule(null);
        resetRecurringDetail({
            interval: 1,
            frequency: FREQ_WEEKLY,
            recurringPattern: RECURRING_PATTERN_INDEF,
            totalSessionsNumber: null,
            cronologicalOrCalendarDay: "CRONO",
            untilDate: null,
            recurringWeekDays: []
        });
        setSBs(null);
        props.closeRescheduleModal();
    }

    return (
        <>
            <ProviderRescheduleConfirmationModal
                open={showConfirmationMessage}
                onClose={() => setShowConfirmationMessage(false)}
                onConfirm={() => {
                    setShowConfirmationMessage(false);
                    handleConfirmation();
                }}
                originalRrule={originalRRule}
                newRrule={rrule}
            />

            <Dialog
                open={recurringBookingAllOrSelectedOverride}
                onClose={() => {
                    resetOnClose();
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    This booking is part of a recurring bookings set
                </DialogTitle>
                <DialogContent sx={{ paddingRight: "10px" }}>
                    <Typography>
                        Would you like to override all upcoming bookings, or
                        just the selected booking?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => submitReschedulingHandler(booking)}
                        variant="contained"
                        color="primary"
                        autoFocus
                    >
                        Selected booking
                    </Button>
                    <Button
                        onClick={() => handleOverrideRecurringBookings(booking)}
                        variant="contained"
                        color="primary"
                        autoFocus
                    >
                        All upcoming bookings
                    </Button>
                </DialogActions>
            </Dialog>
            <CustomDateTimeDialog open={showCustomDateTimeDialog} />

            <ThemeProvider theme={DialogTheme(theme)}>
                {/* Reschedule Modal */}
                <Dialog
                    onClose={() => {
                        resetOnClose();
                    }}
                    open={props.rescheduleModal}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle sx={{ paddingBottom: "18px" }}>
                        Reschedule
                        {` ${currentBookingClientName}`}
                    </DialogTitle>
                    {(showBackdrop ||
                        isLoadingUnavailableTimeblocks ||
                        isLoadingGeoLocation ||
                        !SBs) &&
                        !isRescheduling && (
                            <DialogContent sx={{ minHeight: "300px" }}>
                                <Backdrop
                                    sx={{
                                        backgroundColor:
                                            "transparent !important"
                                    }}
                                    open={true}
                                >
                                    <CircularProgress color="primary" />
                                </Backdrop>
                            </DialogContent>
                        )}

                    {!(
                        (showBackdrop ||
                            isLoadingUnavailableTimeblocks ||
                            isLoadingGeoLocation ||
                            !SBs) &&
                        !isRescheduling
                    ) && (
                        <DialogContent>
                            {props?.selectedRowData?.orderType ===
                                "ONGOING" && (
                                <Grid
                                    container
                                    item
                                    direction="column"
                                    sx={{ padding: "18px 0px" }}
                                >
                                    <Alert
                                        severity={"warning"}
                                        variant="recurringBookingAlert"
                                        icon={false}
                                    >
                                        This booking is part of a recurring
                                        booking set
                                    </Alert>
                                </Grid>
                            )}
                            {isRescheduling && (
                                <Backdrop
                                    sx={{
                                        zIndex: (theme) =>
                                            theme.zIndex.modal + 1,
                                        position: "absolute",
                                        backgroundColor:
                                            "transparent !important"
                                    }}
                                    open={true}
                                >
                                    <CircularProgress color="primary" />
                                </Backdrop>
                            )}
                            <Grid
                                item
                                container
                                direction={"row"}
                                columnSpacing={2.25}
                                pb="5px"
                                sx={{
                                    alignItems: "flex-start",
                                    [theme.breakpoints.up("md")]: {
                                        flexWrap: "nowrap"
                                    },
                                    [theme.breakpoints.down("sm")]: {
                                        justifyContent: "center"
                                    }
                                }}
                            >
                                <Grid
                                    item
                                    sx={{
                                        marginTop: "11px",
                                        maxWidth: "273px"
                                    }}
                                >
                                    <LocalizationProvider
                                        dateAdapter={AdapterDateFns}
                                        adapterLocale={customLocale}
                                    >
                                        <StaticDatePicker
                                            variant="rescheduleModal"
                                            disabled={disableCalendar}
                                            displayStaticWrapperAs="desktop"
                                            openTo="day"
                                            value={calendarDate}
                                            onChange={async (newValue) => {
                                                let actualDateTime = newValue;
                                                if (new Date() !== newValue) {
                                                    actualDateTime.setHours(8);
                                                    actualDateTime.setMinutes(
                                                        0
                                                    );
                                                    actualDateTime.setMilliseconds(
                                                        0
                                                    );
                                                }
                                                setError(false);
                                                setCalendarDate(actualDateTime);
                                                setHasDateOrTimeChanged(true);
                                                if (
                                                    showRecurrenceSettingsSection
                                                )
                                                    setRecurringWeekDays(
                                                        actualDateTime
                                                    );
                                                checkIsDuringBlockedTime(
                                                    actualDateTime
                                                );
                                                setStoredSuggestions(null);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} />
                                            )}
                                            minDate={new Date()}
                                            PopperProps={{
                                                disablePortal: true,
                                                placement: "bottom-end"
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                {!showNormalSlots &&
                                    !hideSuggestions &&
                                    geoLoc &&
                                    SBs?.length && (
                                        <SuggestedTimesSection
                                            SBs={SBs}
                                            isOngoing={
                                                props.selectedRowData
                                                    ?.orderType === "ONGOING"
                                            }
                                            setHasDateOrTimeChanged={() =>
                                                setHasDateOrTimeChanged(true)
                                            }
                                            handleSelectedCustomDateTime={() => {
                                                setShowNormalSlots(true);
                                                setSuggestionLookAheadStartDate(
                                                    null
                                                );
                                            }}
                                        />
                                    )}
                                {(showNormalSlots || hideSuggestions) && (
                                    <Grid
                                        container
                                        item
                                        sx={{
                                            flexDirection: "column",
                                            justifyContent: "flex-start",
                                            alignItems: "flex-start",
                                            paddingLeft: "1rem"
                                        }}
                                    >
                                        <>
                                            {!hideSuggestions &&
                                                SBs?.length !== 0 && (
                                                    <Button
                                                        sx={{
                                                            alignSelf:
                                                                "flex-start",
                                                            textTransform:
                                                                "none",
                                                            textWrap: "nowrap",
                                                            marginTop: "18px",
                                                            height: "14px",
                                                            "&:hover": {
                                                                backgroundColor:
                                                                    "unset",
                                                                color: theme
                                                                    .palette
                                                                    .primary
                                                                    .dark
                                                            }
                                                        }}
                                                        startIcon={<WestIcon />}
                                                        onClick={() => {
                                                            setSelectedRescheduleDateTime(
                                                                null
                                                            );
                                                            setSuggestionLookAheadStartDate(
                                                                calendarDate
                                                            );
                                                            setShowNormalSlots(
                                                                false
                                                            );
                                                        }}
                                                    >
                                                        Back to time suggestions
                                                    </Button>
                                                )}
                                            <RescheduleSlotsList
                                                selectedTime={
                                                    selectedRescheduleDateTime
                                                        ? format(
                                                              utcToZonedTime(
                                                                  selectedRescheduleDateTime,
                                                                  booking
                                                                      .provider
                                                                      .timezone
                                                              ),
                                                              "h:mm a",
                                                              {
                                                                  timeZone:
                                                                      booking
                                                                          .provider
                                                                          .timezone
                                                              }
                                                          )
                                                        : booking.bookingTime.replace(
                                                              /^0/,
                                                              ""
                                                          )
                                                }
                                                onSelectTime={async (
                                                    slotTime
                                                ) => {
                                                    setHasDateOrTimeChanged(
                                                        true
                                                    );
                                                    let t = new Date(
                                                        calendarDate
                                                    );

                                                    t.setHours(
                                                        slotTime.split(":")[0]
                                                    );
                                                    t.setMinutes(
                                                        slotTime.split(":")[1]
                                                    );
                                                    t.setMilliseconds(0);
                                                    //make isBlocked call here
                                                    //   checkIsDuringBlockedTime(t); //pankaj: check logic
                                                    const dateTimeInProviderTz =
                                                        await getBookingDateDescriptionInTimezone(
                                                            t,
                                                            booking?.provider
                                                                ?.timezone,
                                                            30
                                                        );
                                                    setSelectedRescheduleDateTime(
                                                        new Date(
                                                            dateTimeInProviderTz.dtstamp_str
                                                        )
                                                    );
                                                    if (
                                                        booking?.orderType ===
                                                            "ONGOING" &&
                                                        showRecurrenceSettingsSection
                                                    )
                                                        setRecurringWeekDays(t);
                                                }}
                                            />
                                        </>
                                    </Grid>
                                )}
                            </Grid>
                            {isRecurringBooking &&
                                showRecurrenceSettingsSection && (
                                    <div>
                                        {
                                            <Grid
                                                container
                                                item
                                                xs={12}
                                                variant="repeatingSetup"
                                            >
                                                <RepeatingSetup
                                                    toggleCustomDateTimeDialogVisibility={() =>
                                                        setShowCustomDateTimeDialog(
                                                            (
                                                                showCustomDateTimeDialog
                                                            ) =>
                                                                !showCustomDateTimeDialog
                                                        )
                                                    }
                                                />
                                            </Grid>
                                        }
                                    </div>
                                )}
                            {error && (
                                <Grid
                                    container
                                    item
                                    sx={{
                                        justifyContent: "center",
                                        paddingTop: "36px"
                                    }}
                                >
                                    <Alert
                                        severity={errorType}
                                        sx={{
                                            padding: "0px 8px 0px 12px",
                                            margin: "0px",
                                            "& .MuiAlert-icon": {
                                                alignSelf: "center"
                                            }
                                        }}
                                        variant="outlined"
                                    >
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            sx={{
                                                fontSize: "12px"
                                            }}
                                        >
                                            {errorMessage}
                                        </Box>
                                    </Alert>
                                </Grid>
                            )}
                        </DialogContent>
                    )}
                    <DialogActions sx={{ paddingTop: "31px" }}>
                        <Grid
                            container
                            item
                            gap={"18px"}
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end"
                            }}
                        >
                            <Button variant="outlined" onClick={resetOnClose}>
                                Cancel
                            </Button>
                            <Button
                                disabled={
                                    isRecurringBooking
                                        ? loading ||
                                          (rrule === originalRRule &&
                                              !hasDateOrTimeChanged)
                                        : loading || !hasDateOrTimeChanged
                                }
                                variant="contained"
                                onClick={() => {
                                    setShowConfirmationMessage(true);
                                }}
                            >
                                Reschedule
                            </Button>
                        </Grid>
                    </DialogActions>
                </Dialog>
            </ThemeProvider>
        </>
    );
}
const CustomDateTimeDialog = ({ open }) => {
    const [customTimeActions] = useAtom(customTimeActionsAtom);
    const [{ date, time }, setDateTime] = useState({ date: null, time: null });
    return (
        <>
            <Dialog open={open}>
                <DialogTitle>Custom date and time</DialogTitle>
                <DialogContent>
                    <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={customLocale}
                    >
                        <DatePicker
                            // autoFocus
                            label="Date"
                            renderInput={(props) => <TextField {...props} />}
                            value={date}
                            onChange={(date) =>
                                setDateTime({
                                    time: time,
                                    date
                                })
                            }
                        />
                        <TimePicker
                            label="time"
                            renderInput={(props) => <TextField {...props} />}
                            value={time}
                            onChange={(time) =>
                                setDateTime({
                                    date: date,
                                    time
                                })
                            }
                        />
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    customTimeActions.cancel();
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                disabled={!date || !time}
                                onClick={() => {
                                    customTimeActions.save({ date, time });
                                }}
                            >
                                OK
                            </Button>
                        </DialogActions>
                    </LocalizationProvider>
                </DialogContent>
            </Dialog>
        </>
    );
};
export default ProviderRescheduleModal;
